<script>
  export default {
    props: {
      title: {
        type: String,
        required: false,
        default: ''
      },
      text: {
        type: String,
        required: true,
        default: ''
      },
      small: {
        type: Boolean,
        default: false
      },
      type: {
        default: 'primary',
        validator: val => ['primary', 'secondary'].includes(val)
      }
    },
    computed: {
      wrapperClasses () {
        if (this.type === 'secondary') {
          if (this.small) {
            return 'border-2 border-gray-200 bg-white  -mt-32 w-72'
          }
          return 'border-2 border-gray-200 bg-white -mt-32  w-96'
        }
        return 'bg-blue-500 text-white -mt-36  w-96'
      },
      arrowClasses () {
        if (this.type === 'secondary') {
          return 'bg-white border-b-2 border-r-2 -bottom-3'
        }
        return 'bg-blue-500 -bottom-2'
      }
    }
  }
</script>

<template>
  <div
    :class="wrapperClasses"
    class="absolute flex-col justify-center hidden p-4 font-normal transform -translate-x-1/2 rounded-lg lg:flex left-1/2"
  >
    <p>
      <strong
        v-if="title"
        class="mb-1"
      >
        {{ title }}
      </strong>
    </p>
    {{ text }}
    <span
      class="absolute w-5 h-5 -ml-2 transform rotate-45 left-1/2"
      :class="arrowClasses"
    />
  </div>
</template>
